import { render, staticRenderFns } from "./remitDefiniteForPayList.vue?vue&type=template&id=19f56127&scoped=true"
import script from "./remitDefiniteForPayList.vue?vue&type=script&lang=js"
export * from "./remitDefiniteForPayList.vue?vue&type=script&lang=js"
import style0 from "./remitDefiniteForPayList.vue?vue&type=style&index=0&id=19f56127&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f56127",
  null
  
)

export default component.exports